class coffeeTools {
  constructor() {}
  createSectionTitle(
    title_text,
    container,
    more_link = false,
    more_link_url = ""
  ) {
    let title_container = document.createElement("div");
    title_container.classList.add("section_container", "clearfix");

    let dot = document.createElement("span");
    dot.classList.add("section_dot");

    title_container.appendChild(dot);

    let title = document.createElement("div");
    title.classList.add("section_title");
    title.innerHTML = title_text;

    title_container.appendChild(title);

    container.appendChild(title_container);
    if (more_link) {
      let more_link_anchor = document.createElement("a");
      more_link_anchor.href = more_link_url;
      more_link_anchor.classList.add("more_link_anchor");

      let more_link_text = document.createElement("span");
      more_link_text.innerHTML = "Ver más";
      more_link_anchor.appendChild(more_link_text);

      let more_link_icon = document.createElement("img");
      more_link_icon.src = "1B_Vermasflecha.svg";
      more_link_anchor.appendChild(more_link_icon);

      title_container.appendChild(more_link_anchor);
    }
  }

  test(number) {
    return number + 1;
  }

  showRotateBanner(img_id = "js__banner_image") {
    //Prepare the request data.
    var ajax_data = {
      id_section: 10,
      count_banners: 1,
      url_link: 1,
      id_device: 1
    };

    fetch(process.env.REACT_APP_BASE_URL + "/analytics/banners/view", {
      method: "Post",
      credentials: "omit",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(ajax_data)
    })
      .then((response) => response.json())
      .then((response) => {
        console.log("response", response);
        if (
          response.items[0].item.full_url_image != null &&
          !response.items[0].item.full_url_image.includes("no-image.jpg")
        ) {
          const banners = document.querySelectorAll("#js__banner_image_anchor");
          banners.forEach((banner) => {
            banner.setAttribute("href", response.items[0].item.url_link);
          });

          let image = document.getElementById(img_id);
          if (image != null) {
            image.setAttribute(
              "src",
              process.env.REACT_APP_BASE_URL +
                response.items[0].item.full_url_image
            );
          }
        }
      });
  }
}

export default coffeeTools;
